export const SEARCH_TYPES = {
  MAKE_MODEL: { value: 'make-model', label: 'Vehicle Make & Model' },
  REGO: { value: 'rego', label: 'Victorian Number Plate' },
} as const;
